export default __webpack_public_path__ + "static/media/sa.83713640.svg";